import { EARLY_JOIN_MINUTES, LATE_JOIN_MINUTES, RECENTLY_ENDED_MINUTES } from 'src/constants/sessionTimer';

// Helper function to get session status with timing information
export const getSessionStatus = (session: any) => {
  const now = new Date();
  const sessionStart = new Date(session.scheduled_at);
  const sessionEnd = new Date(sessionStart.getTime() + (session.duration_min * 60 * 1000));
  
  // If session hasn't started yet
  if (now < sessionStart) {
    const timeDiff = sessionStart.getTime() - now.getTime();
    const minutesUntil = Math.floor(timeDiff / (1000 * 60));
    const hoursUntil = Math.floor(minutesUntil / 60);
    
    if (minutesUntil < 60) {
      return {
        status: 'upcoming',
        label: `Starts in ${minutesUntil}m`,
        variant: 'default' as const,
        canJoin: minutesUntil <= EARLY_JOIN_MINUTES
      };
    } else if (hoursUntil < 24) {
      return {
        status: 'upcoming',
        label: `Starts in ${hoursUntil}h ${minutesUntil % 60}m`,
        variant: 'default' as const,
        canJoin: false
      };
    } else {
      return {
        status: 'scheduled',
        label: 'Scheduled',
        variant: 'default' as const,
        canJoin: false
      };
    }
  }
  
  // If session is currently running
  if (now >= sessionStart && now <= sessionEnd) {
    const minutesElapsed = Math.floor((now.getTime() - sessionStart.getTime()) / (1000 * 60));
    return {
      status: 'live',
      label: `Live (${minutesElapsed}m elapsed)`,
      variant: 'destructive' as const, // Red for urgency
      canJoin: true
    };
  }
  
  // If session ended recently
  const minutesSinceEnd = Math.floor((now.getTime() - sessionEnd.getTime()) / (1000 * 60));
  if (minutesSinceEnd <= RECENTLY_ENDED_MINUTES) {
    return {
      status: 'recently_ended',
      label: `Ended ${minutesSinceEnd}m ago`,
      variant: 'secondary' as const,
      canJoin: minutesSinceEnd <= LATE_JOIN_MINUTES
    };
  }
  
  // Default fallback
  return {
    status: session.status,
    label: session.status,
    variant: 'secondary' as const,
    canJoin: false
  };
};

// Helper function to get simple session status for timeline dots
export const getSimpleSessionStatus = (session: any) => {
  const now = new Date();
  const sessionStart = new Date(session.scheduled_at);
  const sessionEnd = new Date(sessionStart.getTime() + (session.duration_min * 60 * 1000));
  
  if (now < sessionStart) {
    return "upcoming";
  } else if (now >= sessionStart && now <= sessionEnd) {
    return "current";
  } else {
    return "completed";
  }
};